import React, { useState } from 'react';
import * as S from './LoginButton.style';
import { useStore } from '../../store/useStore';
import { requestMagicLink } from '../../services/api';
import { trackEvent } from '../../services/analytics';

export const LoginButton: React.FC = () => {
  const { tier } = useStore();
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{
    text: string;
    type: 'success' | 'error';
  } | null>(null);

  // Only render for unauthenticated users
  if (tier !== 'preview' && tier !== 'blocked') {
    return null;
  }

  const openModal = () => {
    trackEvent('login_modal_opened_desktop');
    setShowModal(true);
    setEmail('');
    setMessage(null);
    setLoading(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setMessage(null);
    setLoading(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || loading) return;

    setLoading(true);
    setMessage(null);
    trackEvent('magic_link_request_login_attempt');

    try {
      await requestMagicLink(email);
      trackEvent('magic_link_request_login_success');
      setMessage({
        text: 'Check your email for the magic link',
        type: 'success',
      });
    } catch (err) {
      trackEvent('magic_link_request_login_error');
      setMessage({
        text: err instanceof Error ? err.message : 'Failed to send email',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <S.LoginBtn onClick={openModal}>[ log in ]</S.LoginBtn>

      {showModal && (
        <S.Overlay onClick={closeModal}>
          <S.Card onClick={(e) => e.stopPropagation()}>
            <S.Title>log in</S.Title>
            <S.Description>
              If you already have an account, enter your email and a magic link will be sent to log
              you back in.
            </S.Description>
            <S.Form onSubmit={handleSubmit}>
              <S.Input
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
                autoFocus
              />
              <S.Button type="submit" disabled={loading || !email}>
                {loading ? '[ sending... ]' : '[ send magic link ]'}
              </S.Button>
              <S.SecondaryButton type="button" onClick={closeModal}>
                [ cancel ]
              </S.SecondaryButton>
              {message && <S.Message $type={message.type}>{message.text}</S.Message>}
            </S.Form>
          </S.Card>
        </S.Overlay>
      )}
    </>
  );
};
